export default "__VITE_ASSET__Dz5FsO5X__"